"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.SurveyStatusesToJSON = exports.SurveyStatusesFromJSONTyped = exports.SurveyStatusesFromJSON = exports.instanceOfSurveyStatuses = void 0;
var runtime_1 = require("../runtime");
var SurveyQuestionType1_1 = require("./SurveyQuestionType1");
var SurveyStatusLikelihood_1 = require("./SurveyStatusLikelihood");
var SurveyStatusPacing_1 = require("./SurveyStatusPacing");
/**
 * Check if a given object implements the SurveyStatuses interface.
 */
function instanceOfSurveyStatuses(value) {
    var isInstance = true;
    return isInstance;
}
exports.instanceOfSurveyStatuses = instanceOfSurveyStatuses;
function SurveyStatusesFromJSON(json) {
    return SurveyStatusesFromJSONTyped(json, false);
}
exports.SurveyStatusesFromJSON = SurveyStatusesFromJSON;
function SurveyStatusesFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'questionType': !(0, runtime_1.exists)(json, 'question_type') ? undefined : (0, SurveyQuestionType1_1.SurveyQuestionType1FromJSON)(json['question_type']),
        'controlStatus': !(0, runtime_1.exists)(json, 'control_status') ? undefined : (0, SurveyStatusPacing_1.SurveyStatusPacingFromJSON)(json['control_status']),
        'exposedStatus': !(0, runtime_1.exists)(json, 'exposed_status') ? undefined : (0, SurveyStatusPacing_1.SurveyStatusPacingFromJSON)(json['exposed_status']),
        'ageStatus': !(0, runtime_1.exists)(json, 'age_status') ? undefined : (0, SurveyStatusLikelihood_1.SurveyStatusLikelihoodFromJSON)(json['age_status']),
        'genderStatus': !(0, runtime_1.exists)(json, 'gender_status') ? undefined : (0, SurveyStatusLikelihood_1.SurveyStatusLikelihoodFromJSON)(json['gender_status']),
        'formatStatus': !(0, runtime_1.exists)(json, 'format_status') ? undefined : (0, SurveyStatusLikelihood_1.SurveyStatusLikelihoodFromJSON)(json['format_status']),
        'frequencyStatus': !(0, runtime_1.exists)(json, 'frequency_status') ? undefined : (0, SurveyStatusLikelihood_1.SurveyStatusLikelihoodFromJSON)(json['frequency_status']),
    };
}
exports.SurveyStatusesFromJSONTyped = SurveyStatusesFromJSONTyped;
function SurveyStatusesToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'question_type': (0, SurveyQuestionType1_1.SurveyQuestionType1ToJSON)(value.questionType),
        'control_status': (0, SurveyStatusPacing_1.SurveyStatusPacingToJSON)(value.controlStatus),
        'exposed_status': (0, SurveyStatusPacing_1.SurveyStatusPacingToJSON)(value.exposedStatus),
        'age_status': (0, SurveyStatusLikelihood_1.SurveyStatusLikelihoodToJSON)(value.ageStatus),
        'gender_status': (0, SurveyStatusLikelihood_1.SurveyStatusLikelihoodToJSON)(value.genderStatus),
        'format_status': (0, SurveyStatusLikelihood_1.SurveyStatusLikelihoodToJSON)(value.formatStatus),
        'frequency_status': (0, SurveyStatusLikelihood_1.SurveyStatusLikelihoodToJSON)(value.frequencyStatus),
    };
}
exports.SurveyStatusesToJSON = SurveyStatusesToJSON;
